import { useEffect, useState } from "react";
import Confirmation from "../../components/confirmation";
import Footer from "../../components/footer";
import NavBar from "../../components/navbar";
import { useAuth } from "../../context/authprovider";
import { topicListApi } from "../../services/topic";

export type TopicList = {
  id: number;
  topicTitle: string;
  topicDesc: string;
};

const DeleteTopic = () => {
  const [topics, setTopics] = useState<TopicList[]>();
  const [deleteType, setDeleteType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedTopicIndex, setSelectedTopicIndex] = useState(-1);
  const { userId } = useAuth();

  useEffect(() => {
    const loadTopicList = async () => {
      const topicLists = await topicListApi();
      if (topicLists) {
        setTopics(topicLists.topics);
      }
    };
    loadTopicList();
  }, []);

  return (
    <>
      <NavBar />
      <div className="mt-20">
        <div className="flex flex-wrap">
          <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Topic Title
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Topic Description
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {topics &&
                    topics.map((topic) => (
                      <tr key={topic.id}>
                        {openModal && topic.id == selectedTopicIndex && (
                          <Confirmation
                            show={openModal}
                            userId={userId!}
                            id={topic.id}
                            onToggle={setOpenModal}
                            selectedIndex={setSelectedTopicIndex}
                            deleteType={deleteType}
                          />
                        )}
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {topic.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {topic.topicTitle}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {topic.topicDesc}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <button
                            className="text-indigo-600 hover:text-indigo-900"
                            type="button"
                            onClick={() => {
                              setDeleteType("deleteTopic");
                              setOpenModal(true);
                              setSelectedTopicIndex(topic.id);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DeleteTopic;
